export const formatCredits = (
  value?: number | null,
  options: Intl.NumberFormatOptions = {},
): string => {
  const amount = Number(value ?? 0);
  if (!Number.isFinite(amount)) return '0';

  const absAmount = Math.abs(amount);
  const maximumFractionDigits = options.maximumFractionDigits ?? (absAmount < 1 && absAmount > 0 ? 4 : 2);
  const minimumFractionDigits = options.minimumFractionDigits ?? 0;

  return amount.toLocaleString(undefined, {
    minimumFractionDigits,
    maximumFractionDigits,
    ...options,
  });
};

export const stripCreditUnits = (value?: string | number | null): string => {
  if (value === null || value === undefined) return '';
  return String(value)
    .replace(/\bminute\s+tokens?\b/gi, 'credits')
    .replace(/\bMT\b/g, '')
    .replace(/\s{2,}/g, ' ')
    .trim();
};

export const formatPlanCredits = (display?: string | null, amount?: number | null): string => {
  const normalized = stripCreditUnits(display);
  if (normalized) return normalized;
  if (amount === null || amount === undefined) return 'Unlimited';
  return formatCredits(amount);
};
